import Styles from './styles.module.css';
import React from 'react';
import { TbNumber1Small, TbNumber2Small, TbNumber3Small, TbNumber4Small, TbNumber5Small, TbNumber6Small, TbNumber7Small, TbNumber8Small } from 'react-icons/tb';
import { PiCheckCircleFill } from 'react-icons/pi';
import { VscChevronRight } from 'react-icons/vsc';
import { sections, publicDoc } from './publishLogic';

type SchoolNavigation = {
  documentId: string;
  progress: boolean[];
  changeData: boolean;
  navigation: number;
  setNavigation: React.Dispatch<React.SetStateAction<number>>;
  setBackCaution: React.Dispatch<React.SetStateAction<number>>;
};


const SchoolNavigation: React.FC<SchoolNavigation> = ({ documentId, progress, changeData, navigation, setNavigation, setBackCaution }) => {

  const numberIcons = [
    <TbNumber1Small className={Styles.nav_number} />,
    <TbNumber2Small className={Styles.nav_number} />,
    <TbNumber3Small className={Styles.nav_number} />,
    <TbNumber4Small className={Styles.nav_number} />,
    <TbNumber5Small className={Styles.nav_number} />,
    <TbNumber6Small className={Styles.nav_number} />,
    <TbNumber7Small className={Styles.nav_number} />,
    <TbNumber8Small className={Styles.nav_number} />,
  ];

  return (
    <>
    <div className={Styles.navigation} style={{overflowY: 'scroll'}}>
      <h4 className={Styles.navigation_title}>求人の編集</h4>

      {sections.map((label, index) => {
        const num = index + 1;
        const isActive = navigation === num;
        const isCompleted = progress[num - 1];

        return (
          <div className={Styles.navigation_item}
            key={num} onClick={() => changeData && navigation !== num ? setBackCaution(num) : setNavigation(num) }
            style={{ backgroundColor: isActive ? "#EBEBEB" : "", cursor: "pointer" }}>
            <p>
              {numberIcons[index]}
              {label}
            </p>

            {isCompleted ? (
              <PiCheckCircleFill className={Styles.save} />
            ) : (
              <VscChevronRight className={Styles.unSave} />
            )}
          </div>
        );
      })}

      <button className={Styles.save_btn} onClick={() => progress.slice(0, 9).every(Boolean) ? publicDoc(documentId) : ''}
        style={progress.slice(0, 9).every(Boolean) ? {} : { backgroundColor: '#fafafa', color: '#cccccc', border: '1px solid #EBEBEB',  boxShadow: 'none', fontWeight: '400' }}>
          公開
      </button>

    </div>
    </>
  );
}

export default SchoolNavigation;
